(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[801],{

/***/ 977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(8278);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sign_up; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./src/components/footer-nav.tsx
var footer_nav = __webpack_require__(8445);
// EXTERNAL MODULE: ./src/components/page-layout.tsx
var page_layout = __webpack_require__(6299);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(9425);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(1248);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chakra-ui-toast.esm.js
var chakra_ui_toast_esm = __webpack_require__(6933);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chakra-ui-radio.esm.js
var chakra_ui_radio_esm = __webpack_require__(9680);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.module.js + 1 modules
var zod_module = __webpack_require__(6522);
// EXTERNAL MODULE: ./src/components/logo.tsx
var logo = __webpack_require__(7510);
// EXTERNAL MODULE: ./src/components/radio-card.tsx
var radio_card = __webpack_require__(6940);
// EXTERNAL MODULE: ./src/components/section-card.tsx
var section_card = __webpack_require__(5444);
// EXTERNAL MODULE: ./src/components/section-group.tsx
var section_group = __webpack_require__(1568);
// EXTERNAL MODULE: ./src/components/stripe-payment-method.tsx + 1 modules
var stripe_payment_method = __webpack_require__(7051);
// EXTERNAL MODULE: ./src/features/auth/utils.ts
var utils = __webpack_require__(6736);
// EXTERNAL MODULE: ./src/features/recipient-count/index.tsx
var recipient_count = __webpack_require__(6616);
// EXTERNAL MODULE: ./src/hooks/use-get-prices.ts
var use_get_prices = __webpack_require__(2892);
// EXTERNAL MODULE: ./src/libs/supabase.ts + 46 modules
var supabase = __webpack_require__(2257);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./src/types/index.ts + 4 modules
var types = __webpack_require__(613);
;// CONCATENATED MODULE: ./src/features/sign-up/types.ts


var signUpFormDataSchema = lib/* object */.Ry({
    email: lib/* string */.Z_().email(),
    password: lib/* string */.Z_().min(6),
    recipientCount: lib/* number */.Rx(),
    billingPeriod: types/* billingPeriodSchema */.jz,
    paymentMethod: lib/* string */.Z_().min(1)
});

// EXTERNAL MODULE: ./src/features/sign-up/utils.ts
var sign_up_utils = __webpack_require__(8519);
;// CONCATENATED MODULE: ./src/features/sign-up/index.tsx





















var defaultBilled = "yearly";
var billingPeriods = [
    "yearly",
    "monthly"
];
var SignUpForm = function() {
    var router = (0,next_router.useRouter)();
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var recipientCount = (0,es/* useSelector */.v9)(function(state) {
        return state.recipientCount;
    }).recipientCount;
    var ref = (0,react.useState)(), paymentMethod = ref[0], setPaymentMethod = ref[1];
    var ref1 = (0,use_get_prices/* useGetPrices */.i)(), monthlyPrice = ref1.monthlyPrice, yearlyMonthlyPrice = ref1.yearlyMonthlyPrice;
    var ref2 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod_module/* zodResolver */.F)(signUpFormDataSchema),
        shouldUseNativeValidation: false,
        reValidateMode: "onBlur",
        mode: "onBlur",
        defaultValues: {
            email: "",
            password: "",
            billingPeriod: defaultBilled,
            recipientCount: 1,
            paymentMethod: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id : ""
        }
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid, setValue = ref2.setValue, watch = ref2.watch;
    // Synchronize paymentMethod state with RHF
    (0,react.useEffect)(function() {
        setValue("paymentMethod", (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id : "", {
            shouldValidate: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentMethod
    ]);
    // Synchronize recipientCount state with RHF
    (0,react.useEffect)(function() {
        setValue("recipientCount", recipientCount, {
            shouldValidate: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recipientCount
    ]);
    var billingPeriod = watch("billingPeriod");
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, user, session, _$error, subscriptionResponse, subscription;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return supabase/* supabase.auth.signUp */.O.auth.signUp({
                            email: values.email,
                            password: values.password
                        });
                    case 2:
                        ref = _ctx.sent;
                        user = ref.user;
                        session = ref.session;
                        _$error = ref.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        toast({
                            title: "An error occurred",
                            description: _$error.message ? _$error.message : "An error occurred, please try again",
                            status: "error",
                            isClosable: true
                        });
                        console.error(_$error);
                        return _ctx.abrupt("return");
                    case 10:
                        if (user) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error("User data not found in sign up");
                    case 12:
                        _ctx.next = 14;
                        return (0,utils/* setAuthCookie */.M)(session, "SIGNED_IN");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.next = 17;
                        return fetch("/api/create-subscription", {
                            method: "POST",
                            body: JSON.stringify({
                                email: values.email,
                                paymentMethod: values.paymentMethod,
                                billingPeriod: values.billingPeriod,
                                recipientCount: values.recipientCount
                            })
                        });
                    case 17:
                        subscriptionResponse = _ctx.sent;
                        _ctx.next = 20;
                        return subscriptionResponse.json();
                    case 20:
                        subscription = _ctx.sent;
                        if (subscriptionResponse.ok) {
                            _ctx.next = 23;
                            break;
                        }
                        throw new Error(subscription.message);
                    case 23:
                        router.push("/dashboard");
                        _ctx.next = 30;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](14);
                        toast({
                            title: "An error occurred",
                            description: _ctx.t0 ? "".concat(_ctx.t0) : "An error occurred, please try again",
                            status: "error",
                            isClosable: true
                        });
                        console.error(_ctx.t0);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    14,
                    26
                ]
            ]);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCharge = function() {
        var price = (0,sign_up_utils/* getMonthlyPrice */.W)(billingPeriod, recipientCount, monthlyPrice, yearlyMonthlyPrice);
        if (billingPeriod === "monthly") {
            return "$".concat(price, " monthly");
        } else {
            return "$".concat(price * 12, " yearly");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_card/* SectionCard */.q, {
            title: "Sign up",
            footerSlot: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFooter, {
                isValid: isValid,
                isSubmitting: isSubmitting,
                charge: getCharge()
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAccount, {
                        register: register,
                        errors: errors
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanDetails, {
                        setValue: setValue,
                        errors: errors
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_group/* SectionGroup */.P, {
                        title: "Payment method",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stripe_payment_method/* StripePaymentMethod */.Y, {
                            paymentMethod: paymentMethod,
                            onAddPaymentMethod: function(paymentMethod) {
                                return setPaymentMethod(paymentMethod);
                            },
                            onRemovePaymentMethod: function() {
                                return setPaymentMethod(undefined);
                            }
                        })
                    })
                ]
            })
        })
    });
};
var CreateAccount = function(param) {
    var register = param.register, errors = param.errors;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(section_group/* SectionGroup */.P, {
        title: "Create account",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: Boolean(errors.email),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "email",
                            children: "Email address"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            maxW: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                id: "email",
                                type: "email"
                            }, register("email", {
                                required: "Email is required"
                            })))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: Boolean(errors.password),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "password",
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            maxW: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                id: "password",
                                type: "password"
                            }, register("password", {
                                required: "Password is required"
                            })))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var PlanDetails = function(param) {
    var errors = param.errors, setValue = param.setValue;
    var ref;
    var ref1 = (0,use_get_prices/* useGetPrices */.i)(), monthlyPrice = ref1.monthlyPrice, yearlyMonthlyPrice = ref1.yearlyMonthlyPrice;
    var recipientCount = (0,es/* useSelector */.v9)(function(state) {
        return state.recipientCount;
    }).recipientCount;
    var getRadioProps = (0,chakra_ui_radio_esm/* useRadioGroup */.ar)({
        name: "billingPeriod",
        defaultValue: "yearly",
        onChange: function(v) {
            return setValue("billingPeriod", v, {
                shouldValidate: true
            });
        }
    }).getRadioProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(section_group/* SectionGroup */.P, {
        title: "Subscription details",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            spacing: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: Boolean(errors.recipientCount),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "recipientCount",
                            hidden: true,
                            children: "Number of recipients"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(recipient_count/* RecipientSlider */.G, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (ref = errors.recipientCount) === null || ref === void 0 ? void 0 : ref.message
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                    spacing: 4,
                    children: billingPeriods.map(function(billingPeriod) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_card/* RadioCard */.R, (0,_object_spread/* default */.Z)({
                            label: billingPeriod === "monthly" ? "Billed monthly" : "Billed yearly",
                            info: "$".concat((0,sign_up_utils/* getMonthlyPrice */.W)(billingPeriod, recipientCount, monthlyPrice, yearlyMonthlyPrice), "/month (First month free!)")
                        }, getRadioProps({
                            value: billingPeriod
                        })), billingPeriod);
                    })
                })
            ]
        })
    });
};
var SectionFooter = function(param) {
    var isValid = param.isValid, isSubmitting = param.isSubmitting, charge = param.charge;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        justifyContent: "space-between",
        gap: 4,
        flexDir: {
            base: "column-reverse",
            lg: "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "center",
                gap: 4,
                flexDir: {
                    base: "column-reverse",
                    lg: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                        spacing: 0,
                        textAlign: {
                            base: "center",
                            lg: "right"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "xs",
                                children: [
                                    "Subscribe today and get your ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "first month free"
                                    }),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "xs",
                                children: [
                                    "After your first month, your card will be charged ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: charge
                                    }),
                                    " until canceled."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        isLoading: isSubmitting,
                        disabled: !isValid || isSubmitting,
                        type: "submit",
                        children: "Complete sign up"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/sign-up.tsx






var SignUp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_layout/* PageLayout */.X, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* Seo */.p, {
                title: "Sign up for Joyline.io"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxW: "4xl",
                py: {
                    base: 4,
                    lg: 16
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        h: 8
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_nav/* FooterNav */.H, {
                        colorScheme: "medium-gray"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sign_up = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [260,445,962,527,61,998,773,428,164,774,888,179], function() { return __webpack_exec__(977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);